import { Link } from "@tanstack/react-router";
import { useState } from "react";
import { authClient } from "../lib/auth-client";

export function ForgotPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    const { error } = await authClient.requestPasswordReset({
      email,
      redirectTo: "/reset-password",
    });
    setBusy(false);
    // Always show success to avoid leaking which emails exist.
    if (error && error.status !== 200) {
      // Still show the neutral success message; log for debugging only.
      console.warn("requestPasswordReset:", error.message);
    }
    setSent(true);
  }

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <div className="auth-brand">
          Founder<span>Deck</span>
        </div>
        <div className="auth-sub">Reset your password.</div>

        {sent ? (
          <>
            <div className="form-ok">
              If an account exists for <b>{email}</b>, a reset link is on its way.
            </div>
            <div className="auth-foot">
              <Link to="/login">Back to sign in</Link>
            </div>
          </>
        ) : (
          <>
            {error && <div className="form-err">{error}</div>}
            <form onSubmit={onSubmit}>
              <div className="field">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  type="email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <button className="btn" type="submit" disabled={busy}>
                {busy ? "Sending…" : "Send reset link"}
              </button>
            </form>
            <div className="auth-foot">
              <Link to="/login">Back to sign in</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
